import { Alert } from "@icg360/design-system";

import { useFlags } from "utils";

export const StatusMessageAlert = () => {
  const { statusMessage } = useFlags();
  if (!isStatusMessage(statusMessage)) {
    return null;
  }

  return (
    <Alert
      appearance={statusMessage.appearance}
      title={statusMessage.title}
      description={statusMessage.description}
    />
  );
};

export type StatusMessage = {
  appearance: "info" | "success" | "warning" | "danger";
  title: string;
  description: string;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isStatusMessage(value: any): value is StatusMessage {
  return (
    value != null &&
    typeof value.title === "string" &&
    typeof value.description === "string" &&
    (value.appearance === "info" ||
      value.appearance === "success" ||
      value.appearance === "warning" ||
      value.appearance === "danger")
  );
}
